import { type ReactNode } from 'react'
import { Spinner } from './Button'

export function EmptyState({ icon = 'ri-inbox-line', message, action }: { icon?: string; message: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-14 text-center">
      <span className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-surface2 text-2xl text-muted">
        <i className={icon} aria-hidden />
      </span>
      <p className="text-13 text-muted">{message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}

export function LoadingState({ message = 'Carregando...' }: { message?: string }) {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="flex items-center gap-3 text-13 text-muted">
        <Spinner className="h-6 w-6 text-primary" />
        {message}
      </div>
    </div>
  )
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 text-center">
      <span className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-expense/10 text-2xl text-expense">
        <i className="ri-error-warning-line" aria-hidden />
      </span>
      <p className="text-13 text-expense">{message}</p>
    </div>
  )
}
